import { State, County, Country } from '../../signups/geography'

export class CurrentAddress {
    addressLine1: string;
    addressLine2: string;
    zip: string;
    city: string;
    state: string;
    country: string;
    county: string;
}